<template>
  <div class="box">
    <el-row :gutter="10">
      <el-col :span="12"
              v-for="item in listArr"
              :key="item.jobCode">
        <info :item="item"></info>
        <!--  -->
        <!-- <div class="main"
             @click="toDeta">
          <div class="main_left">
            <div class="main_top">
              <p class="main_txt">苏宁物流每天坐班包吃包住宿</p>
              <div class="main_icon">包食宿</div>
              <div class="main_icon">免费培训</div>
            </div>
            <p class="main_bot">广州茂源人力资源有限公司</p>
          </div>
          <div class="main_right">440元/天</div>
        </div> -->
        <!--  -->
      </el-col>
    </el-row>
    <el-pagination background
                   v-if="listArr.length>0"
                   @current-change="handleCurrentChange"
                   :current-page="currentPage"
                   :page-size="size"
                   layout="prev, pager, next"
                   :total="total">
    </el-pagination>
  </div>
</template>

<script>
import info from '@/components/info'

export default {
  components: {
    info,
  },
  data () {
    return {
      currentPage: 1,
      size: 12,
      listArr: [],
      total: 0
    }
  },
  created () {
    this.getListInfo(this.currentPage);
  },
  methods: {
    toDeta () {
      this.$router.push({ name: 'details' });
    },
    getListInfo (page) {
      let param = {
        type: 2,
        pageNo: page,
        pageSize: this.size,
        jobType: 1
      };
      this.$get("/app/api/v1/verify/all", param)
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.listArr = res.data.info;
            this.total = res.data.total;
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
        .catch((err) => { });
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getListInfo(this.currentPage);
    }
  },
}
</script>

<style scoped>
.box {
  width: 100%;
  margin-top: 10px;
  padding: 5px 15px 30px;
  border: 1px solid #f5f5f5;
}
>>> .el-pagination {
  text-align: center;
  margin-top: 30px;
}
>>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #e53631;
}
/* main */
.main {
  width: 540px;
  height: 88px;
  background: #f9f9f9;
  border-radius: 2px;
  margin-top: 10px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main_left {
  display: flex;
  flex-direction: column;
}
.main_top {
  display: flex;
}
.main_txt {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.main_icon {
  padding: 1px 2px;
  font-size: 14px;
  color: #e53631;
  background: #ffe6e5;
  border-radius: 2px;
  margin-left: 5px;
}
.main_bot {
  font-size: 16px;
  color: #999999;
  line-height: 16px;
  margin-top: 15px;
}
.main_right {
  font-size: 20px;
  font-weight: 600;
  color: #e53631;
  line-height: 20px;
}
</style>